export default "__VITE_ASSET__4cdb958a__"